import React, { useState, useRef, useCallback, useMemo } from "react";
import useInput from "../../hooks/useInput";
import { useAppDispatch } from "../../store";
import { useSelector } from "react-redux";
import { RootState } from "../../reducer/index";
// import styled from "styled-components";
import styled, { createGlobalStyle } from "styled-components/macro";
import { useEffect } from "react";
import { GetWeather, GetWeathertemp, Getenvirdata, } from "../../reduxaction/post";
import OuterCon from "../../components/OuterCon";
import { AccmuLightType, Farmstype, LightType, lightsensoreType, sensorstype, } from "../../reducer/postpayloadtypes";
import Select from "react-select";

import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Chart, registerables, ArcElement, } from "chart.js";
// import style from "src/styles/pages/chart/chart.module.scss";
// import { Line } from "react-chartjs-2";
import LineChart from "../../components/LineChart ";
// import Tab from "../../components/Tab";
import axios from "axios";
import * as styles from "../../styles/DiaryPage";
import { Navigate, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import userSlice from "../../reducer/user";
import { LoadFarm } from "../../reduxaction/post";

// 사육환경별 그래프 부분 페이지 import
import EnvirdataCrossCon from "./EnvirdataCrossCon";

dayjs.locale("ko");
Chart.register(...registerables);




interface Selected {
  selected?: boolean;
}

const EnvirdataPage = () => {
  const { Farms, Targetfarms, Diarylist, Weathertemp, Weather, envirdata } = useSelector((state: RootState) => state.post);
  const { me } = useSelector((state: RootState) => state.user);

  const navigate = useNavigate();

  const [tabIndex, setTabIndex] = useState<number>(0);
  const tabs = ["조명 IN", "조명 OUT"];
  const [selectedOption, setSelectedOption] = useState<any>({
    // value: 2,
    // label: "귀뚜라미 계통1",
    label: "GICC0003S",
    value: 3,
  });
  const [selectsensor, setSelectsensor] = useState<sensorstype[]>([]);
  const [selectlight, setSelectlight] = useState<LightType[]>([]);
  const [time, setTime] = useState<string>(
    dayjs(new Date()).format("HH:mm:00")
  );
  const [light, setLight] = useState<LightType[]>([]);
  const [accmulight, setAccmulight] = useState<AccmuLightType[]>([]);
  const dispatch = useAppDispatch();


  const targetFarmInfo = JSON.parse(localStorage.getItem("targetfarmInfo") || "{}");
  // 실제 값을 비교하기 위해 useMemo 사용
  const targetFarmInfoMemo = useMemo(() => targetFarmInfo, [JSON.stringify(targetFarmInfo)]);

  const [equipsList, setEquipsList] = useState<any[]>([]);
  const [sensorList, setSensorList] = useState<any[]>([]);

  //LINK - EnvirdataCrossCon Component state
  const [ECCstate, setECCstate] = useState<boolean>(false);



  //! 💛 mount 시 정보 가져오기

  // 농장 정보 세팅
  useEffect(() => {
    dispatch(LoadFarm());
  }, [dispatch, me]);

  // useEffect(() => {
  //   dispatch(userSlice.actions.Routerpath("/EnvirdataPage"));
  // }, []);



  // 필요 데이터 호출
  useEffect(() => {
    if (!targetFarmInfo) return;

    fn_getWeather(targetFarmInfo); // 날씨 정보 세팅
    // fn_setEquipsList(targetFarmInfo); // 장비 정보 세팅
    fn_setSensorList(targetFarmInfo); // 센서 정보 세팅
    fn_getLightdata(targetFarmInfo); // 조명 정보 세팅
    fn_getAccmuLightdata(targetFarmInfo); // 누적 조명 정보 세팅
  }, [targetFarmInfoMemo]);

  const fn_getWeather = useCallback((targetFarmInfo: any) => {
    if (!targetFarmInfo) return;

    const data = { longitude: targetFarmInfo.longitude, latitude: targetFarmInfo.latitude };
    dispatch(GetWeather(data));
    dispatch(GetWeathertemp(data));
  }, [targetFarmInfoMemo]);

  const fn_setEquipsList = useCallback((targetFarmInfo: any) => {
    if (!targetFarmInfo) return;

    getequipsList(targetFarmInfo.placeId)
      .then((response) => {
        setEquipsList(response);
      }).catch((error) => {
        console.error(error);
      });
  }, [targetFarmInfoMemo]);

  const fn_setSensorList = useCallback((targetFarmInfo: any) => {
    if (!targetFarmInfo) return;

    getSensorListInfo(targetFarmInfo.placeId)
      .then((response) => {
        setSensorList(response);
      }).catch((error) => {
        console.error(error);
      });
  }, [targetFarmInfoMemo]);

  const fn_getLightdata = useCallback((targetFarmInfo: any) => {
    if (!targetFarmInfo) return;

    getLightdata(targetFarmInfo.placeId)
      .then((response) => {
        setLight(response);
        setSelectlight([response[0]]);
      }).catch((error) => {
        console.error(error);
      });
  }, [targetFarmInfoMemo]);

  const fn_getAccmuLightdata = useCallback((targetFarmInfo: any) => {
    if (!targetFarmInfo) return;

    getAccmuLightdata(targetFarmInfo.placeId)
      .then((response) => {
        setAccmulight(response);
      }).catch((error) => {
        console.error(error);
      });
  }, [targetFarmInfoMemo]);

  //! 💛 API 
  // 장비정보 가져오기
  const getequipsList = async (placeId: number) => {
    try {
      const response = await axios.get(`ifactory/api/place/placetag/${placeId}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  // 센서 리스트 정보 가져오기
  const getSensorListInfo = async (placeId: number) => {
    try {
      const response = await axios.get(`ifactory/api/tag/${placeId}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  // 조명 정보 가져오기
  const getLightdata = async (placeId: number) => {
    try {
      const response = await axios.get(`ifactory/api/record/light?placeId=${placeId}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  // 누적 조명 시간 정보 가져오기
  const getAccmuLightdata = async (placeId: number) => {
    try {
      const response = await axios.get(`ifactory/api/record/accumlight?placeId=${placeId}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };


  // const outersensors = Targetfarms?.equips[0].sensors;

  const sky = Weather.filter((v) => v.category === "SKY");

  const skyvalues = () => {
    let skyvalue = "";

    if (sky[0]) {
      switch (sky[0].fcstValue) {
        case "1":
          skyvalue = "맑음";
          break;
        case "3":
          skyvalue = "구름조금";
          break;
        case "4":
          skyvalue = "흐림";
          break;
      }
      return skyvalue;
    }
  };

  const shorttemp = Weather.filter((v) => v.category === "T1H");

  const today = new Date();
  const day = dayjs(today).format("YYYY년 MM월 DD일 dddd HH시 mm분");

  let products: string[] = [];

  Targetfarms?.children.map((v) => {
    products.push(v.productCode);
  });

  // 컨테이너와 상자에 있는 센서 불러오는 함수
  let contaiers = Targetfarms?.children.filter((v) => v.type === "CONTAINER");

  const boxs = contaiers?.map((v) =>
    v.children.filter((v) => v.type === "BOX")
  );

  let filterbox: any = boxs?.reduce(function (acc: any, cur: any) {
    return acc.concat(cur);
  });

  let mixeditem = contaiers?.concat(filterbox);

  const filterdata = mixeditem?.sort((pre, past) =>
    pre.name < past.name ? -1 : 1
  );
  let insects = filterdata?.map((place) => {
    return { value: place.placeId, label: place.name };
  });
  // ----------chart js code
  const boxes = new Array(3).fill(null);
  const selectsensors = filterdata?.filter(
    (place: Farmstype) => place.placeId === selectedOption?.value
  );
  const sensors = selectsensors?.[0]?.equips[0]?.sensors;

  // 센서 선택 함수
  const selectsenfunc = useCallback(
    (sensor: sensorstype) => {
      setSelectsensor([...selectsensor, sensor]);

      const hasSensor = selectsensor.find((v) => v.tagId === sensor.tagId);

      if (hasSensor) {
        const hello = selectsensor.filter(
          (item) => item.tagId !== hasSensor?.tagId
        );
        setSelectsensor([...hello]);
      }
    },
    [selectsensor]
  );

  const selectlightfunc = useCallback(
    (sensor: LightType) => {
      setSelectlight([sensor]);
    },
    [selectlight]
  );
  useEffect(() => {
    setSelectsensor([]);
  }, [selectedOption]);

  const newstartDate = new Date();

  newstartDate.setMonth(newstartDate.getMonth() - 1);

  return (
    <Container>
      <styles.PageTop>
        <p className="pagetit">환경 데이터</p>
        <p className="move-btn">
          <img
            src="./img/X.svg"
            onClick={() => {
              navigate(-1);
            }}
            alt="X"
          />
        </p>
      </styles.PageTop>
      <WeatherCon>
        <WeatherImgDiv>
          <img src="/img/weather_clear.svg" />
        </WeatherImgDiv>
        <WeatherInfo>
          <Time>{day}</Time>
          <WeatherInfoRow>
            <WeatherInfo1>
              {skyvalues()}
              <span>
                {shorttemp[0]?.fcstValue}
                <span className="first">℃</span>
              </span>
            </WeatherInfo1>
            <WeatherInfo2>
              최저
              <span>
                {Weathertemp?.dayMinTemp}
                <span>℃</span>
              </span>
            </WeatherInfo2>
            <WeatherInfo3>
              최고
              <span>
                {Weathertemp?.dayMaxTemp}
                <span>℃</span>
              </span>
            </WeatherInfo3>
          </WeatherInfoRow>
        </WeatherInfo>
      </WeatherCon>

      <CrossLine></CrossLine>


      {/* EnvirdataCrossCon Component 파일을 삽입 */}
      {/* 
				1. 다 EnvirdataCrossCon에서 처리
			*/}
      <EnvirdataCrossCon setECCstate={setECCstate} />

      {/* targetFarmInfoMemo.placeId 가 1일때만 하위 내역을 그림 */}
      {targetFarmInfoMemo.placeId === 1 && (
        <>
          <CrossLine></CrossLine>

          <LightCon>
            <LightTxt>조명 ON / OFF </LightTxt>

            <SelectLightCon>
              {light?.map((sensor: LightType, idx: number) => {
                const sensorlight = selectlight.filter(
                  (select) => select.sectionName === sensor.sectionName
                );

                return (
                  <SelectLights key={idx}
                    selected={sensorlight[0]?.sectionName === sensor.sectionName}
                    onClick={() => selectlightfunc(sensor)}
                  >
                    <div style={{ width: 50, textAlign: "center" }}>
                      {sensor.sectionName}
                    </div>
                  </SelectLights>
                );
              })}
            </SelectLightCon>

            <BoxesCon>
              {selectlight[0]?.sectionBoxNames?.map((box, idx: number) => {
                return <Boxes key={idx}>{box}</Boxes>;
              })}
            </BoxesCon>

            <LightWapper>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <LightBox
                  style={{
                    // width: "10%",

                    display: "flex",
                    alignItems: "cneter",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    <p style={{ textAlign: "center" }}>조명ON</p>
                  </div>
                </LightBox>

                {selectlight[0]?.sensor.map((v: lightsensoreType, i: number) => {
                  const ligtinF = dayjs(v.lightIn).format("YYYY년 MM월 DD일");

                  const ligtinS = dayjs(v.lightIn).format("dddd HH시 mm분");

                  return (
                    <LightBox key={v.lightIn + i}>
                      <div>
                        <p className={`in ${v.state === 'ON' ? 'emphasis' : ''}`}>{ligtinF} </p>
                        <p className={`in ${v.state === 'ON' ? 'emphasis' : ''}`}>{ligtinS} </p>
                      </div>
                    </LightBox>
                  );
                })}
              </div>
            </LightWapper>

            <LightWapper>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <LightBox
                  style={{
                    alignItems: "cneter",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    <p>조명OFF</p>
                  </div>
                </LightBox>

                {selectlight[0]?.sensor.map((v: lightsensoreType, i: number) => {
                  const lightoutF = dayjs(v.lightOut).format("YYYY년 MM월 DD일");

                  const lightoutS = dayjs(v.lightOut).format("dddd HH시 mm분");

                  return (
                    <LightBox key={v.lightIn + i}>
                      <p className={`out ${v.state === 'OFF' ? 'emphasis' : ''}`}>{lightoutF}</p>
                      <p className={`out ${v.state === 'OFF' ? 'emphasis' : ''}`}>{lightoutS}</p>
                    </LightBox>
                  );
                })}
              </div>
            </LightWapper>
          </LightCon>
          <CrossLine></CrossLine>

          <LightCon>
            <LightTxt> 누적 조명시간 </LightTxt>

            <AccmuLightWapper>
              {accmulight.map((v, i) => {
                const { sectionName, sensor } = v;
                const { totalLightTime } = sensor;
                const timeString = totalLightTime;
                const [day, hour, minute, second] = timeString
                  .split(":")
                  .map(Number);

                return (
                  <AccmuLightBox key={i}>
                    <p>{v.sectionName}</p>
                    <p style={{ marginTop: 10 }}>
                      {day}일 {hour}시간 {minute}분 {second}초
                    </p>
                  </AccmuLightBox>
                );
              })}
            </AccmuLightWapper>
          </LightCon>
        </>

      )}
    </Container>
  );
};

export default EnvirdataPage;





const Container = styled.div``;

const Header = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  font-weight: bold;
  font-size: 18px;
  color: #2a3a4b;
`;

const WeatherCon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
	align-items: center;
  padding: 20px 0px;
`;

const WeatherImgDiv = styled.div`
  /* border: 1px solid black; */
  /* width: 4%; */
  /* position: relative; */
  /* top: -7px; */
	display: flex;
	justify-content: center;
	align-items: center;

  img {

	}
`;

const WeatherInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const Time = styled.div`
  color: #000000;
  font-size: 16px;
  font-weight: 500;
`;

const WeatherInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 6px;
  align-items: center;
`;

const WeatherInfo1 = styled.div`
  color: #979797;
  font-size: 18px;
  font-weight: 500;
  margin: 3px;
  span {
    color: #242424;
    font-size: 25px;
    font-weight: 700;
  }
  .first {
    font-size: 14px;
  }
`;

const WeatherInfo2 = styled.div`
  color: #377cff;
  font-weight: 500;
  font-size: 14px;
  margin: 3px;
  margin-left: 7px;
  font-weight: 800;
  span {
    color: #242424;
    font-weight: 500;
  }
`;

const WeatherInfo3 = styled.div`
  color: #dd6868;
  font-weight: 800;
  margin: 3px;
  margin-left: 7px;
  span {
    color: #242424;
    font-weight: 500;
  }
`;

const OuterSensors = styled.div`
  background-color: #f5f5f5;

  display: flex;
  justify-content: center;
  padding: 30px;
`;

// const OuterCon = styled.div`
//   margin: 10px;
//   text-align: center;
//   font-size: 18px;
//   color: #979797;
//   font-weight: 500;

//   /* border: 1px solid lightgray; */

//   border-left: 1px solid lightgray;
//   padding-left: 7%;
//   padding-right: 5%;
//   :last-child {
//     border-right: 1px solid lightgray;
//     padding-right: 7%;
//   }
//   div {
//     margin-top: 10px;
//     font-size: 20px;
//     color: #2a3a4b;
//     font-weight: 700;
//   }
// `;

const CrossLine = styled.div`
  display: flex;
  padding: 7px 0px;
  border: 1px solid lightgray;
  background-color: #f5f5f5;
`;

const CrossCon = styled.div`
  display: flex;
  margin-left: 10px;
  margin-top: 10px;
  align-items: center;
`;

const SelectSensorsCon = styled.div`
  display: flex;
`;

const SelectSensoers = styled.div<Selected>`
  background-color: #dddddd;
  margin: 10px;
  padding: 5px 5px;
  border-radius: 10px;
  color: #656565;

  background-color: ${(props) => (props.selected ? "#2A3A4B" : "#DDDDDD")};
  color: ${(props) => (props.selected ? "#FFFFFF" : "#656565")};
  cursor: pointer;
`;

const ChartCont = styled.div`
  font-size: 16px;
  color: #656565;
  margin-right: 20px;
`;

const SelectTiem = styled.div`
  margin-left: 10px;
  input {
    border: 1px solid #73972c;
    padding: 8px 10px;
    border-radius: 7px;
  }
`;

const LightCon = styled.div`
  /* background-color: lightblue; */
  /* padding-left: 10px; */
  padding: 20px 40px 30px 40px;
`;

const LightTxt = styled.div`
  font-size: 23px;
  color: #2a3a4b;
  margin-bottom: 20px;
`;

const SelectLightCon = styled.div`
  display: flex;
  margin-bottom: 10px;
  flex-wrap: wrap;
  justify-content: center;
`;

const SelectLights = styled.div<Selected>`
  background-color: #dddddd;
  margin: 10px;
  padding: 5px 5px;
  border-radius: 10px;
  color: #656565;
  background-color: ${(props) => (props.selected ? "#2A3A4B" : "#DDDDDD")};
  color: ${(props) => (props.selected ? "#FFFFFF" : "#656565")};

  /* background-color: ${(props) =>
    props.selected ? "#DDDDDD" : "#2A3A4B"}; */
  /* color: ${(props) => (props.selected ? "#656565" : "#FFFFFF")}; */

  cursor: pointer;
`;

const BoxesCon = styled.div`
  /* background-color: lavender; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
`;

const Boxes = styled.div`
  text-align: center;
  /* width: 80px; */
  padding: 0px 10px;
  height: 30px;
  background-color: #73972c;
  color: #fff;
  margin: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
`;

const LightWapper = styled.div`
  border-bottom: 1px solid #dddddd;
  border-left: 1px solid #dddddd;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  /* background-color: #f5f5f5; */
  /* border-bottom: 1px solid #dddddd;
  border-left: 1px solid #dddddd;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  background-color: #f5f5f5; */
`;

const LightBox = styled.div`
  width: 100%;
  border-top: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
  padding: 15px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 13px;
    margin-bottom: 3px;
		color: #7a7a7a;
		font-weight: 500;

		&.emphasis{
			font-size: 13px;
    	color: #2a3a4b;
    	font-weight: 600;
		}
  }
`;

const AccmuLightWapper = styled.div`
  border-bottom: 1px solid #dddddd;
  border-left: 1px solid #dddddd;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  background-color: #f5f5f5;
`;

const AccmuLightBox = styled.div`
  width: 33.3%;
  border-top: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
  padding: 15px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 14px;
    color: #2a3a4b;
    font-weight: 600;
  }

  p.out {
    font-size: 14px;

    color: #7a7a7a;
    font-weight: 500;
  }
`;

const SerachButton = styled.div`
  background-color: pink;
  margin: 10px;
  width: 50px;
  height: 30px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const Legends = styled.div`
  display: flex;
  display: flex;
  justify-content: center;
  /* align-items: center; */
`;

const Items = styled.div`
  /* background-color: orange; */
  /* display: flex; */
  margin-right: 10px;
  text-align: center;
  width: 70px;
  height: 30px;
`;

const Colors = styled.div`
  background-color: orange;
  width: 70px;
  height: 30px;
  border-radius: 10px;
`;